import { useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'

import Media from '@components/UI/Media/Media'
import { AspectRatios, MediaTypes } from '@enums'
import { IApplicationState } from '@store'
import {
  selectMediaObjectType,
  selectOriginalMediaUrl,
  selectThumbnailMediaUrl,
} from '@store/mediaObjects'
import { selectMediaObjectId } from '@store/router'
import Theme from '@theme'

export const MediaObjectFullMedia = () => {
  const match = useRouteMatch()
  const mediaObjectId = useSelector(
    (state: IApplicationState) => selectMediaObjectId(match) as number,
  )
  const mediaType = useSelector((state: IApplicationState) =>
    selectMediaObjectType(state, mediaObjectId!),
  )
  const thumbnailUrl = useSelector((state: IApplicationState) =>
    selectThumbnailMediaUrl(state, mediaObjectId!),
  )
  const originalUrl = useSelector((state: IApplicationState) =>
    selectOriginalMediaUrl(state, mediaObjectId!),
  )

  return (
    <Media
      src={thumbnailUrl}
      mediaType={mediaType}
      aspectRatio={AspectRatios.ONE_BY_ONE}
      backgroundColor={Theme.whiteColor}
      fullSizeSrc={originalUrl}
      controls
      expandable
      containImage
    />
  )
}

export default MediaObjectFullMedia
